import { gql } from "@apollo/client";

export const GridViewRotationTime = gql`
    query GridViewRotationTime ($id: ID!) {
        gridView (id: $id ) {
            id
            rotationTime
        }
    }
`;
